import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import Notifications from "vue-notification";
import "vue-loading-overlay/dist/vue-loading.min.css";
import {
  faTimes,
  faSave,
  faCaretRight,
  faCaretDown,
  faTrashAlt,
  faPen,
  faUpload
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import axios from 'axios';

library.add(faTimes, faSave, faCaretRight, faCaretDown, faTrashAlt, faPen, faUpload);
Vue.component("font-awesome-icon", FontAwesomeIcon);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("../firebase-messaging-sw.js")
    .then(registration => {
      // console.log("Registration successful, scope is:", registration.scope);
    })
    .catch(err => {
      // console.log("Service worker registration failed, error:", err);
    });
}

Vue.config.productionTip = false;

Vue.use(Vuetify);
Vue.use(Notifications);

router.beforeEach(async(to, from, next) => {
  axios.defaults.withCredentials = true;
  
  if (to.name === "login"){
    next();
  } else {
    try {
      let user = await store.getters.user;
      if (!user || !user.permission) {
        let getUser = await store.dispatch("getUser");
        let sessionUser = getUser.data.result;
        store.commit("setUser", sessionUser);
      }
      if (!axios.defaults.headers.post["X-CSRF-Token"]) {
        let token = await axios.get(store.state.host + "api/v1/csrfToken");
        axios.defaults.headers.post["X-CSRF-Token"] = token.data._csrf;
        axios.defaults.headers.delete["X-CSRF-Token"] = token.data._csrf;
        axios.defaults.headers.put["X-CSRF-Token"] = token.data._csrf;
      }
      next();
    } catch (err) {
      store.commit("setShowNotification", {
        type: "error",
        title: "ERROR",
        text: "El usuario no esta autenticado"
      });
      next("/login");
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
